<div class="spacerWrapper" fxLayout="column">
    <h2 mat-dialog-title class="dialogTitle">{{ dialogTitle }}</h2>

    <div mat-dialog-content>
        <form [formGroup]="bulletinForm" class="grid-container">
            <div class="inputContainer bTitle">
                <label>Title</label>
                <mat-form-field appearance="outline">
                    <input matInput formControlName="Title" />
                </mat-form-field>
            </div>

            <!-- <div class="inputContainer bLink">
                <label>Link</label>
                <mat-form-field appearance="outline">
                    <input matInput formControlName="Link" />
                </mat-form-field>
            </div> -->

            <div class="inputContainer bType">
                <label>Type</label>
                <mat-form-field appearance="outline">
                    <mat-select formControlName="Type">
                        <mat-option value="">Select a Type</mat-option>
                        <mat-option value="Red">Red</mat-option>
                        <mat-option value="Yellow">Yellow</mat-option>
                        <mat-option value="Blue">Blue</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="inputContainer bActive">
                <mat-checkbox formControlName="Active" aria-label="Active"> Active </mat-checkbox>
            </div>

            <div class="inputContainer bMessage">
                <label>Message</label>
                <!-- <mat-form-field appearance="outline"> -->
                    <editor formControlName="Message" [init]="editorConfig"></editor>
                <!-- </mat-form-field> -->
            </div>

            <div class="inputContainer bStartDate">
                <label>Start Date</label>
                <mat-form-field appearance="outline">
                    <input matInput type="datetime-local" formControlName="StartDate" />
                </mat-form-field>
            </div>

            <div class="inputContainer bEndDate">
                <label>Ending Date</label>
                <mat-form-field appearance="outline" [class.mat-form-field-invalid]="bulletinForm.hasError('endDateInvalid')">
                    <input matInput type="datetime-local" formControlName="EndDate" />
                </mat-form-field>
            </div>

            <!-- <div class="inputContainer bStartDate">
                <label>Start Date</label>
                <mat-form-field appearance="outline">
                    <input matInput formControlName="StartDate" [matDatepicker]="startDatePicker" placeholder="MM/DD/YYYY" />
                    <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #startDatePicker></mat-datepicker>
                </mat-form-field>
            </div>

            <div class="inputContainer bEndDate">
                <label>Ending Date</label>
                <mat-form-field appearance="outline" [class.mat-form-field-invalid]="bulletinForm.hasError('endDateInvalid')">
                    <input matInput formControlName="EndDate" [matDatepicker]="endDatePicker" placeholder="MM/DD/YYYY" />
                    <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #endDatePicker></mat-datepicker>
                </mat-form-field>
            </div> -->

            <!-- <div class="inputContainer bStartTime">
                <label>Start Time</label>
                <mat-form-field appearance="outline">
                    <input matInput type="time" formControlName="StartTime" />
                </mat-form-field>
            </div>

            <div class="inputContainer bEndTime">
                <label>Ending Time</label>
                <mat-form-field appearance="outline" [class.mat-form-field-invalid]="bulletinForm.hasError('endTimeInvalid')">
                    <input matInput type="time" formControlName="EndTime" />
                </mat-form-field>
            </div> -->

            <div class="bAudience" *ngIf="creating">
              <h4>School Audience</h4>
              <hr />
              <p>
                  Use the buttons bellow to select which school websites will display this bulletin. By default all schools will receive
                  this bulletin.
              </p>

              <div style="padding-bottom: 10px;">
                  <mat-button-toggle-group #audience="matButtonToggleGroup" aria-label="School Audience" [value]="selectedAudience" (change)="toggleAudience($event)">
                      <mat-button-toggle value="All">All</mat-button-toggle>
                      <mat-button-toggle value="GradeLevel">By GradeLevel</mat-button-toggle>
                      <mat-button-toggle value="City">By City</mat-button-toggle>
                      <mat-button-toggle value="School">By School</mat-button-toggle>
                  </mat-button-toggle-group>
              </div>

              <div *ngIf="audience.value === 'All'"
                  style="
                      background-color: #d9edf7;
                      color: #31708f;
                      padding: 15px;
                      margin-bottom: 20px;
                      border: 1px solid #bce8f1;
                      border-radius: 4px;
                  "
              >
                  All Schools will receive this bulletin.
              </div>

                <div [hidden]="audience?.value !== 'GradeLevel'" >
                <!-- <mat-form-field appearance="outline"> -->
                    <mat-selection-list #byGradeLevel formControlName="GradeLevels" [compareWith]="compareFn" (selectionChange)="onSelection($event)">
                        <mat-list-option *ngFor="let gl of bulletin.gradeLevels" [value]="gl" checkboxPosition="before">
                            {{ gl.gradeLevel }}
                        </mat-list-option>
                    </mat-selection-list>
                <!-- </mat-form-field> -->
                </div>

                <div [hidden]="audience?.value !== 'City'" >
                <!-- <mat-form-field appearance="outline"> -->
                    <mat-selection-list #byCity formControlName="Cities" [compareWith]="compareFn" (selectionChange)="onSelection($event)">
                        <mat-list-option *ngFor="let c of bulletin.cities" [value]="c" checkboxPosition="before">
                            {{ c.city }}
                        </mat-list-option>
                    </mat-selection-list>
                <!-- </mat-form-field> -->
                </div>


                <div [hidden]="audience?.value !== 'School'" >
                <!-- <mat-form-field appearance="outline"> -->
                    <mat-selection-list #bySchool formControlName="Schools" [compareWith]="compareFn" (selectionChange)="onSelection($event)">
                        <mat-list-option *ngFor="let s of bulletin.schools" [value]="s" checkboxPosition="before">
                            {{ s.schoolName }} ({{ s.schoolNumber }})
                        </mat-list-option>
                    </mat-selection-list>
                <!-- </mat-form-field> -->
                </div>
                    
            </div>

            <div class="bAudience" *ngIf="!creating">
                <h4>Selected School(s)</h4>
                <hr />
  
                  <!-- <mat-form-field appearance="outline"> -->
                      <mat-selection-list #selectedSchools formControlName="Schools" [compareWith]="compareFn" (selectionChange)="onSelection($event)">
                          <mat-list-option *ngFor="let s of bulletin.schools" [value]="s" checkboxPosition="before">
                              {{ s.schoolName }} ({{ s.schoolNumber }})
                          </mat-list-option>
                      </mat-selection-list>
                  <!-- </mat-form-field> -->
              </div>

        </form>
    </div>
    <div class="spacer" fxFlex></div>
    <div mat-dialog-actions align="end">
        <button mat-raised-button type="submit" color="primary" (click)="onSubmit(bulletinForm.value)">OK</button>
        <button mat-raised-button type="button" (click)="onNoClick()">Cancel</button>
    </div>

</div>
